module.exports = __webpack_public_path__ + "media/flags/005-portugal-c03ef0c5.svg";